import styled from 'styled-components';

import { OptionsContainerProps } from '.';
import { getAlign } from './helper';

export const Wrapper = styled.ul<Pick<OptionsContainerProps, 'align'>>`
  position: absolute;
  bottom: -5px;
  width: 160px;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  z-index: 20;
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  background-color: ${({ theme }) => theme.colors.white100};

  ${({ align }) => getAlign(align)};
`;
